import { SourceConfig, SourceType } from '../types';

import { avigilonConfig } from './avigilon';
import { hanwhaWaveConfig } from './hanwhawave';
import { rhombusConfig } from './rhombus';
import { verkadaConfig } from './verkada';

export const sourceConfigs: Record<SourceType, SourceConfig> = {
  avigilon: avigilonConfig,
  hanwhawave: hanwhaWaveConfig,
  rhombus: rhombusConfig,
  verkada: verkadaConfig,
};
